"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateDirectInsertConcentrationLimitKickouts = void 0;
const _ = __importStar(require("lodash"));
const common_1 = require("@finley-technologies/common");
const utils_1 = require("./selectFunctions/utils");
/**
 * Calculates concentration and kickouts by grouping the receivables by a single field.
 * This can be used where we want to limit concentration for of each customer or each industry.
 */
const calculateDirectInsertConcentrationLimitKickouts = ({ kickoutValueField, concentrationReceivables, totalConcentrationExposure, }) => {
    const receivableKickoutMap = {};
    let concentrationAmount = 0;
    let totalKickouts = 0;
    for (const receivable of concentrationReceivables) {
        const { finleyReceivableId } = receivable;
        const kickout = (0, utils_1.getFieldValue)({
            loanTape: receivable,
            field: kickoutValueField,
        });
        (0, common_1.finleyAssert)(typeof kickout === 'number', `Invalid value type for [field:${kickoutValueField}]. [Expected type:number] but found [value:${kickout}], [type: ${typeof kickout}]`);
        // sometimes (for example Tioga-Citizen case) the kickout values are specified as negative values.
        // here we use absolute value for kickout, that way we will allow either negative or positive kickout values.
        receivableKickoutMap[finleyReceivableId] = Math.abs(kickout);
        totalKickouts += receivableKickoutMap[finleyReceivableId];
        concentrationAmount +=
            receivable.concentrationLimitFields
                .eligibleExposureLessConcentrationLimitKickouts;
    }
    return {
        kickouts: receivableKickoutMap,
        calculations: {
            concentrationAmount,
            concentrationLimit: concentrationAmount - totalKickouts,
            concentration: _.round(common_1.utils.divideByOrZero(concentrationAmount, totalConcentrationExposure), 10),
        },
    };
};
exports.calculateDirectInsertConcentrationLimitKickouts = calculateDirectInsertConcentrationLimitKickouts;
//# sourceMappingURL=directInsertByField.js.map